module.exports = __webpack_public_path__ + "img/calendar.f40d9ef3.svg";